import { useStoreState } from 'easy-peasy';
import { useTranslation } from 'react-i18next';
import { Modal, PdfPreview } from '@reverse-hr/design-system';
import { DownloadFileButton } from '@components/DownloadFileButton';
import { useDownloadDossier } from '@utils/hooks/use-download-dossier/use-download-dossier';
import {
  candidateSelector,
  curriculumUrlSelector,
} from '@model/Candidate/Candidate.selectors';
import type { FC } from 'react';
import type { TCurriculumModalProps } from '@components/_modals/CurriculumModal/CurriculumModal.types';

export const CurriculumModal: FC<TCurriculumModalProps> = props => {
  const { onClose } = props;

  const { t } = useTranslation('', {
    keyPrefix: 'candidateDetails.dossier',
  });

  const { t: tCommon } = useTranslation('', {
    keyPrefix: 'common',
  });

  const candidate = useStoreState(candidateSelector);
  const curriculumUrl = useStoreState(curriculumUrlSelector);
  const onDossierDownloadClick = useDownloadDossier();

  if (!curriculumUrl) {
    return null;
  }

  const candidateFullName = candidate
    ? tCommon('formatting.fullName', {
        firstName: candidate.firstName,
        lastName: candidate.lastName,
      })
    : '';

  return (
    <Modal className="app-c-curriculum-modal" size="full-size">
      <Modal.Header
        closeButtonAriaLabel={t('modalCloseButtonAriaLabel')}
        isClosable
        onCloseClick={onClose}
        title={t('modalTitle', { candidateFullName })}
      />

      <Modal.Content className="app-c-curriculum-modal__content">
        <PdfPreview file={curriculumUrl} />
      </Modal.Content>

      <Modal.Footer className="app-c-curriculum-modal__footer">
        <DownloadFileButton
          className="app-c-curriculum-modal__download-button"
          iconPosition="right"
          label={t('button')}
          onClick={onDossierDownloadClick}
          variant="primary"
        />
      </Modal.Footer>
    </Modal>
  );
};
